<template>
<main class="sl-home sl-home-classic home-container">
  <header class="sl-topbar"><div class="sl-brand"><img src="/sweetlove-logo.png" alt="SweetLove" /></div><button v-if="!is_login" class="sl-quiet-button" type="button" @click="$router.push('/Register')">{{ $t('auth.no_account') }} <sl-icon name="arrow" /></button><span v-else class="sl-top-label">{{ $t('foorter.index') }}</span></header>
  <div class="home-scroll">
    <div class="sl-home-intro"><section class="sl-hero sl-home-hero"><div><p class="sl-eyebrow">SWEETLOVE · {{ $t('index.Featured_list') }}</p><h1>{{ $t('foorter.index') }}</h1><p class="sl-hero-caption">{{ $t('index.hot') }}<span class="sl-caption-line"></span>{{ $t('index.recmonmand') }}</p></div><div class="sl-hero-orbit" aria-hidden="true"><sl-icon name="heart" /></div></section>
    <div class="banner"><swiper class="banner_swiper" :options="bannerSwiperOption"><swiper-slide v-for="(v,key) in banners" :key="key"><van-image class="banner_img" :src="v.url"><template #loading><van-loading type="circular" /></template></van-image></swiper-slide></swiper></div></div>
    <div class="notice-bar"><van-notice-bar left-icon="volume-o" :text="notice" /></div>
    <div class="sl-summary-strip"><div><span>{{ $t('index.Featured') }}</span><strong>{{ recommend.hot_count || 0 }}</strong><span>{{ $t('index.more') }}</span></div><div><span>{{ $t('index.focus') }}</span><strong>{{ recommend.recommend_count || 0 }}</strong><span>{{ $t('index.hot') }}</span></div></div>
    <van-pull-refresh v-model="isLoading" :pulling-text="$t('reservation.refresh')" :loosing-text="$t('reservation.refreshpage')" :loading-text="$t('reservation.refresh')" :success-text="$t('reservation.refresh')" @refresh="onRefresh">
      <section class="sl-section"><div class="sl-section-heading"><div><p class="sl-eyebrow">{{ $t('index.Featured_list') }}</p><h2>{{ $t('index.hot') }}</h2></div><button class="sl-text-button" type="button" @click="gotoMenu('/Choose')">{{ $t('index.recmonmand') }}<sl-icon name="arrow" /></button></div>
      <div class="sl-media-grid"><button class="sl-media-card" type="button" v-for="(v,key) in visibleFeaturedList" :key="key" @click="profile(v.id)"><van-image class="sl-media-cover" :src="v.img_url"><template #loading><van-loading type="circular" /></template></van-image><div class="sl-media-shade"></div><span class="sl-card-corner"><sl-icon name="heart" /></span><div class="sl-media-caption"><strong>{{ v.xuanfei_name || $t('No information yet') }}</strong><sl-icon name="arrow" /></div></button></div></section>
      <section class="sl-section"><div class="sl-section-heading"><div><p class="sl-eyebrow">{{ $t('index.Private') }}</p><h2>{{ $t('index.more') }}</h2></div></div><div class="sl-media-grid"><button class="sl-media-card" type="button" v-for="(v,key) in visiblePrivateList" :key="key" @click="toPlayVideo(v.id)"><van-image class="sl-media-cover" :src="v.img_url"><template #loading><van-loading type="circular" /></template></van-image><div class="sl-media-shade"></div><span class="sl-media-badge"><sl-icon name="shield" />{{ $t('index.Certification') }}</span><div class="sl-media-caption"><strong>{{ v.xuanfei_name }}</strong><sl-icon name="play" /></div></button></div><button class="sl-load-more" type="button" @click="nextList">{{ $t('index.next') }}<sl-icon name="arrow" /></button></section>
    </van-pull-refresh>
  </div>
</main>
</template>

<script>
import axios from "axios";
export default {
  data() {
    return {
      loggedIn: !!localStorage.getItem("token"),
      notice: this.$t("index.loading"),
      banners: [{}],
      basicData: [],
      gameitem: [{}, {}, {}, {}],
      movielist_0: [{}, {}, {}, {}],
      movielist_1: [{}, {}, {}, {}, {}, {}, {}, {}],
      isLoading: false,
      movielistSwiperOption: {
        slidesPerView: "auto",
        spaceBetween: 0,
        slidesPerGroup: 1,
      },
      bannerSwiperOption: {
        effect: "coverflow",
        grabCursor: true,
        centeredSlides: true,
        slidesPerView: "1",
        speed: 800,
        autoplay: {
          delay: 2000,
          disableOnInteraction: false,
        },
        coverflowEffect: {
          rotate: 50,
          stretch: 10,
          depth: 100,
          modifier: 1,
          slideShadows: true,
        },
      },
      xuan_fei: [],
      choose_page: 1,
      datalist: [],
      num: 4,
      hot_list: [], //热门列表
      recommend: [], //推荐列表
    };
  },
  computed: {
    is_login() {
      return this.loggedIn;
    },
    visibleFeaturedList() {
      return Array.isArray(this.xuan_fei) ? this.xuan_fei.slice(0, 10) : [];
    },
    visiblePrivateList() {
      return Array.isArray(this.datalist) ? this.datalist.slice(0, this.num) : [];
    },
    indexNav() {
      return {
        1: {
          icon: "/img/index_nav/0.png",
          text: this.$t("foorter.subscribe"),
          path: "/Game",
        },
        2: {
          icon: "/img/index_nav/1.png",
          text: this.$t("bulletin"),
          path: "/Notice",
        },
        3: {
          icon: "/img/index_nav/2.png",
          text: this.$t("foorter.Film"),
          path: "/Video",
        },
        4: {
          icon: "/img/index_nav/3.png",
          text: this.$t("concubine.concubine"),
          path: "/Choose",
        },
      };
    },
  },
  methods: {
    updateLoginState() {
      this.loggedIn = !!localStorage.getItem("token");
    },
    consumeRedirectTip() {
      const { redirect_tip, redirect_ts, ...restQuery } = this.$route.query || {};
      if (!redirect_tip) {
        return;
      }
      this.$nextTick(() => {
        if (redirect_tip === "contact_admin") {
          this.$toast(this.$t("reservation.contact_admin"));
        }
      });
      this.$router.replace({
        path: this.$route.path,
        query: restQuery,
      });
    },
    applyCachedHomeData() {
      const cache = localStorage.getItem("home_page_cache_tw");
      if (!cache) return false;
      try {
        const parsed = JSON.parse(cache);
        this.notice = parsed.notice || this.notice;
        this.banners = Array.isArray(parsed.banners) && parsed.banners.length
          ? parsed.banners
          : this.banners;
        this.xuan_fei = Array.isArray(parsed.xuan_fei) ? parsed.xuan_fei : [];
        this.datalist = Array.isArray(parsed.datalist) ? parsed.datalist : [];
        this.hot_list = Array.isArray(parsed.hot_list) ? parsed.hot_list : [];
        this.recommend = parsed.recommend || this.recommend;
        return true;
      } catch (error) {
        return false;
      }
    },
    persistHomeData() {
      localStorage.setItem(
        "home_page_cache_tw",
        JSON.stringify({
          notice: this.notice,
          banners: this.banners,
          xuan_fei: this.xuan_fei,
          datalist: this.datalist,
          hot_list: this.hot_list,
          recommend: this.recommend,
        })
      );
    },
    kefu() {
    },
    async getjiaodianlist() {
      try {
        const res = await axios.get(
          `${process.env.VUE_APP_BASE_API}/xuanfei/xuanfeilist`,
          {
            params: {
              with_stats: 1,
              page: 1,
              plain_json: 1,
            },
          }
        );
        // console.log("拿到的数据", res);
        this.recommend = res.data.data.stats;
        this.persistHomeData();
        // console.log("111", this.recommend);
      } catch (err) {}
    },
    getxiaojielist() {
      return this.$http({
        method: "get",
        url: "xuanfeilist",
        data: {
          page: this.choose_page,
        },
      }).then((res) => {
        const list = Array.isArray(res.data) ? res.data : [];
        if (list.length > 0) {
          if (this.choose_page === 1) {
            this.datalist = list;
          } else {
            this.datalist.push(...list);
          }
          this.persistHomeData();
        } else {
          this.choose_page -= 1;
        }
      });
    },
    profile(id) {
      this.$router.push({ path: "/profile?id=" + id });
    },
    getxuanfeilist() {
      return this.$http({
        method: "get",
        url: "xuanfeilist",
        data: {
          is_ranking: 1,
        },
      }).then((res) => {
        this.xuan_fei = Array.isArray(res.data) ? res.data : [];
        this.hot_list = [];
        this.xuan_fei.forEach((v, i) => {
          if (v.is_hot == 1) {
            this.hot_list.push(v);
            // console.log("热门列表", this.hot_list);
          }
        });
        this.persistHomeData();
      });
    },
    toServicePage() {
      const service = this.$store.getters.getBaseInfo;
      if (service.iskefu == 1) {
        window.location.href = service.kefu;
      }
    },
    nextList() {
      this.choose_page += 1;
      this.getxiaojielist();
      this.num += 4;
    },
    toLottery(key, id) {
      if (!localStorage.getItem("token")) {
        this.$router.push({ path: "/Login" });
      } else {
        this.$router.push({ path: "/Lottery?key=" + key + "&id=" + id });
      }
    },
    toPlayVideo(id) {
      if (!localStorage.getItem("token")) {
        this.$router.push({ path: "/Login" });
      } else {
        this.$router.push({ path: "/profile?id=" + id });
      }
    },
    async onRefresh() {
      this.choose_page = 1;
      this.num = 4;
      this.datalist = [];
      try {
        await Promise.all([
          this.getBasicConfig(),
          this.getxuanfeilist(),
          this.getxiaojielist(),
          this.getjiaodianlist(),
        ]);
        this.$toast(this.$t("reservation.refresh"));
      } finally {
        this.isLoading = false;
      }
    },
    getBasicConfig() {
      return this.$http({
        method: "get",
        url: "sys_config",
      }).then((res) => {
        this.basicData = res.data;
        this.getNotice(this.basicData);
        this.getBanner(this.basicData);
        this.getMovieList_0(this.basicData);
        this.getMovieList_1(this.basicData);
        this.persistHomeData();
        return this.getGameItem();
      });
    },
    getNotice(data) {
      this.notice = data.notice;
    },
    getGameItem() {
      return this.$http({
        method: "get",
        url: "lottery_hot",
      }).then((res) => {
        this.gameitem = res.data;
      });
    },
    getMovieList_0(data) {
      this.movielist_0 = data.movielist_0;
    },
    getMovieList_1(data) {
      this.movielist_1 = data.movielist_1;
    },
    getBanner(data) {
      this.banners = data.banners;
    },
    gotoMenu(index) {
      this.$router.push(index);
    },
  },
  created() {
    this.updateLoginState();
    this.consumeRedirectTip();
    this.applyCachedHomeData();
    this.getBasicConfig();
    this.getxuanfeilist();
    this.getxiaojielist();
    this.getjiaodianlist();
  },
  activated() {
    this.updateLoginState();
  },
};
</script>
